// O painel dedicado de um recurso de IA da área de trabalho de desembolso (planning-workspace):
// um diálogo lateral que existe só enquanto aberto — fechar é desmontar, então nada do
// rascunho sobrevive — e que fecha com Escape ou pelo botão. Quem o monta (a tela) decide
// quando ele existe: nunca em modo apresentação, nunca depois da troca de obra.
//
// O painel de organização do módulo Ampli (`OrganizeWithAiPanel`) já tem esta forma; este é
// o mesmo molde para o recurso da tela legada (o composer de antecipação).
import { useEffect, useRef } from "react";

const AiPanel = ({ title, onClose, children }) => {
  const panelRef = useRef(null);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    panelRef.current?.focus();
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div className="offcanvas active">
      <section
        className="offcanvas-container disbursement-ai-panel"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        ref={panelRef}
      >
        <header className="offcanvas-header">
          <h2>{title}</h2>
          <button type="button" onClick={() => onClose?.()}>
            Fechar
          </button>
        </header>
        <div className="offcanvas-content">{children}</div>
      </section>
    </div>
  );
};

export default AiPanel;
